import { render } from "./recaptchaBox.vue?vue&type=template&id=0951174d"
import script from "./recaptchaBox.vue?vue&type=script&lang=js"
export * from "./recaptchaBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__